import { css } from '@lastbrand/web-ui-styled-system/css'

import { TEST_LOCATORS } from '@src/constants/test-locators'
import Logo from '@src/quince-components/src/atoms/brandLogo/logo.inline.svg'

export interface BrandLogoProps {
  className?: string
  srOnlyLabel?: string
}

export const BrandLogo = ({ className, srOnlyLabel }: BrandLogoProps) => {
  return (
    <>
      {srOnlyLabel !== undefined && (
        <span
          className={css({
            clip: 'rect(0 0 0 0)',
            clipPath: 'inset(50%)',
            height: '1px',
            width: '1px',
            overflow: 'hidden',
            position: 'absolute',
            whiteSpace: 'nowrap',
          })}
        >
          {srOnlyLabel}
        </span>
      )}
      <Logo className={className} role="presentation" data-testid={TEST_LOCATORS.BRAND_LOGO} />
    </>
  )
}

export default BrandLogo
